export const setWorkspaceId = (workspaceId: string) => {
    localStorage.setItem('workspaceId', workspaceId);
    sessionStorage.setItem('workspaceId', workspaceId);
}